import fn from "../helpers/func";
export default {
  methods: {
    async getClientInfo() {
      if (!this.$cookies.get("_uctoken")) return false;

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_GetClientInfo",
        {
          uctoken: this.$cookies.get("_uctoken")
        }
      );
      if (!res.data.info.status) {
        this.$store.commit("main/setState", {
          key: "infoStatus",
          val: "rejected"
        });
        return false;
      } else {
        this.$store.commit("main/setState", {
          key: "infoStatus",
          val: "resolved"
        });
      }
      if (res.status !== 200 || !_.get(res, "data.info")) {
        return false;
      }

      this.$store.commit("main/setStateDeep", {
        key: "cache.unicardUserInfo",
        val: res.data.info
      });

      //// push to the cabinet
    },

    async getTransactions(page = 1, page_size = 10) {
      if (!this.$cookies.get("_uctoken")) return false;
      console.log(page, "page");
      let old_transactions = this.$store.state.main.cache.unicardTransactions
        ? this.$store.state.main.cache.unicardTransactions
        : null;
      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_GetTransactions",
        {
          uctoken: this.$cookies.get("_uctoken"),
          Page: page,
          PageSize: page_size
        }
      );

      if (res.status !== 200 || !_.get(res, "data.info")) {
        return false;
      }
      let new_transactions = res.data.info;
      console.log(new_transactions.data, "new_transactions");
      console.log(old_transactions?.data, "old_transactions");
      let transactions = { ...old_transactions, ...new_transactions };
      if (old_transactions !== null)
        transactions.data = [
          ...old_transactions.data,
          ...new_transactions.data
        ];
      console.log(transactions, "transactions");
      this.$store.commit("main/setStateDeep", {
        key: "cache.unicardTransactions",
        val: old_transactions === null ? res.data.info : transactions
      });

      console.log(transactions, "transactions data");
    },

    async getCards() {
      if (!this.$cookies.get("_uctoken")) return false;

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_GetCards",
        {
          uctoken: this.$cookies.get("_uctoken")
        }
      );

      if (res.status !== 200 || !_.get(res, "data.info")) {
        return false;
      }

      this.$store.commit("main/setStateDeep", {
        key: "cache.unicardCards",
        val: res.data.info
      });
    },

    async getToken() {
      // console.log(this.$route.query.code, this.$cookies.get('_uccode'));
      if (
        !this.$route.query.code ||
        this.$route.query.code === this.$cookies.get("_uccode")
      ) {
        console.log("do nothing");
        return false;
      }

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_getAccessToken",
        {
          uccode: this.$route.query.code
        }
      );
      console.log(res, "resssssssss");
      if (_.get(res, "data.fullOb.id_token")) {
        this.$cookies.set("_logouttoken", res.data.fullOb.id_token);
      }
      if (_.get(res, "data.access_token")) {
        this.$cookies.set("testtt", res.data);
        this.$cookies.set("_uctoken", res.data.access_token);
        this.$cookies.set("_uccode", this.$route.query.code);
      } else {
        this.$cookies.set("testtt", "");
        this.$cookies.set("_uctoken", "");
        this.$cookies.set("_uccode", "");
      }

      // console.log(res, this.$cookies.get('_uccode'));
    },

    async getSpendOptions() {
      if (!this.$cookies.get("_uctoken")) return false;

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_SpendOptions",
        {
          uctoken: this.$cookies.get("_uctoken")
        }
      );

      if (res.status !== 200 || !_.get(res, "data.info")) {
        return false;
      }

      this.$store.commit("main/setStateDeep", {
        key: "cache.spendOptions",
        val: res.data.info
      });
    },
 
    async orderGiftCard(
      name,
      phone,
      orderDetails,
      deliveryType,
      courierDetails
    ) {
      // if (!this.$cookies.get("_uctoken")) return false;

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_order",
        {
          uctoken: this.$cookies.get("_uctoken"),
          name,
          phone,
          orderDetails,
          deliveryType, // number
          courierDetails: null
        }
      );
      console.log(res, "orderres");
      if (res.status !== 200) {
        return false;
      } else {
        return res;
      }
    },

    async req_handler() {
      await this.getToken();
      await this.getClientInfo();
      await this.getTransactions();
      await this.getCards();
      await this.getSpendOptions();
      // await this.checkGiftCardBallance();
    }
  }
};
